import { ACTIONS } from '../action/actionTypes'

const initialState = {
  open: false,
  result: {
    dropdown: [],
  },
  loading: false,
  value: null,
  param: ''
};

export const search = ( state = initialState, action ) => {
  switch ( action.type ) {
    case ACTIONS.OPEN_SEARCH:
      return { ...state, open: action.open };
    case ACTIONS.SET_SEARCH_RESULT:
      const newState = { ...state };
      Object.assign(newState.result, action.result);
      return newState;
    case ACTIONS.SEARCH_LOADING:
      return { ...state, loading: action.loading };
    case ACTIONS.SET_SEARCH_STRING:
      return { ...state, value: action.value };
    case ACTIONS.UPDATE_SEARCH_PARAMS:
      return { ...state, param: action.param };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducer/search_reducer.js